export const iniciarCharWass = (numero) => {

    let num = numero.replaceAll(' ', '')
    num = num.replaceAll('-', '')
    let link = `https://api.whatsapp.com/send?phone=57${num}`
    window.open(link)
}